import SelectedScheme from "components/Scheme/SelectedScheme";
import AlarmWidget from "containers/event/AlarmWidget";
import { useSelectedCompany } from "hooks/useCompany";
import AssetPositionCountWidget from "pages/assetRegister/assets/widgets/AssetPositionCountWidget";
import DailyReadSuccessWidget from "pages/assetRegister/assets/widgets/DailyReadSuccessWidget/DailyReadSuccessWidget";
import LatestTimeSeriesStatsWidget from "pages/assetRegister/assets/widgets/LatestTimeSeriesStatsWidget";
import type React from "react";
import { Col, Container } from "../../components/Theme/grid";
import useSetPageTitle from "../../hooks/setPageTitle";
import useUserHasRoles from "../../hooks/user/getCurrentUserRole.tsx";
import AssetPositionIssueStatsWidget from "../issue/issueStats/AssetPositionIssueStatsWidget.tsx";

export default function DashboardPage(): React.ReactElement {
  useSetPageTitle({
    setPageTitle: ({ company, scheme }) => {
      return scheme
        ? `Dashboard: ${company?.name} - ${scheme.scheme_name}`
        : `Dashboard: ${company?.name}`;
    },
  });

  const company = useSelectedCompany();
  const isSuperAdmin = useUserHasRoles(["superadmin"]);

  return (
    <>
      {company && (
        <Container>
          <Col sm={12} md={4} lg={4} xl={4}>
            <AssetPositionIssueStatsWidget title={"Asset Position Status"} />
          </Col>
          <Col sm={12} md={4} lg={4} xl={4}>
            <LatestTimeSeriesStatsWidget
              title={"Gateway Last Contact"}
              group={"gateway"}
            />
          </Col>
          <Col sm={12} md={4} lg={4} xl={4}>
            <SelectedScheme>
              {(props) => <AlarmWidget {...props} />}
            </SelectedScheme>
          </Col>
          <Col sm={12} md={12} lg={6} xl={6}>
            <DailyReadSuccessWidget />
          </Col>
          <Col
            className={"d-md-none d-sm-none d-xs-none d-lg-block"}
            lg={6}
            xl={6}
          >
            <AssetPositionCountWidget />
          </Col>
        </Container>
      )}
    </>
  );
}
